import React, { useEffect, useState } from 'react';
import { translate } from '../Services/translation';
import QuickSearchList from './QuickSearchList';

const QuickSearchResult = ({
    result,
    selectedItem,
    searchUrl,
    isMobile,
    query,
}) => {
    useEffect(() => {
        let resultList = result?.resultGroups.filter(item => item);

        const data = resultList[0].results;
    }, [result]);

    return (
        <div
            className="quick-search-result__wrapper"
            id="quick-search-results-wrapper"
        >
            <QuickSearchList
                result={result}
                selectedItem={selectedItem}
                isMobile={isMobile}
                query={query}
            />
            <div className="quick-search-result__item quick-search-result__item--show-all">
                <a className="custom-link" href={searchUrl}>
                    <span>{translate('filter.showmore')}&nbsp;</span>(
                    {result.totalHitCount})
                </a>
            </div>
        </div>
    );
};

export default QuickSearchResult;
